import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

export default function PersonalForm({ current_user }) {
  const [formData, setFormData] = useState({
    realname: "",
    email: "",
    login: "",
    password: "",
    confirmPassword: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  useEffect(() => {
    // Устанавливаем дефолтные значения из текущего пользователя
    if (current_user) {
      setFormData({
        realname: current_user.realname || "",
        email: current_user.email || "",
        username: current_user.username || "",
        password: "", // Оставляем пароли пустыми для безопасности
        confirmPassword: "",
      });
    }
  }, [current_user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword((prev) => !prev);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password !== formData.confirmPassword) {
      toast.error("Пароли не совпадают");
      return;
    }

    try {
      const response = await fetch("/settings/personal_update", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      console.log(response)
      if (response.ok) {
        toast.success("Данные успешно сохранены");
      } else {
        toast.error("Ошибка при сохранении данных");
      }
    } catch (error) {
      toast.error("Произошла ошибка сети");
    }
  };

  return (
    <div className="max-w-4xl mx-auto bg-white p-8 rounded-lg shadow-lg">
      <ToastContainer />
      <h2 className="text-2xl font-semibold mb-6">Настройки пользователя</h2>
      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label htmlFor="realname" className="block text-gray-700">
            ФИО пользователя
          </label>
          <input
            type="text"
            id="realname"
            name="realname"
            value={formData.realname}
            onChange={handleChange}
            placeholder="Введите ФИО"
            className="w-full mt-1 p-2 border border-gray-300 rounded-lg focus:ring focus:ring-blue-500"
            required
          />
        </div>

        <div>
          <label htmlFor="email" className="block text-gray-700">
            E-mail
          </label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Введите email"
            className="w-full mt-1 p-2 border border-gray-300 rounded-lg focus:ring focus:ring-blue-500"
            required
          />
        </div>

        <div>
          <label htmlFor="username" className="block text-gray-700">
            Логин (имя для входа)
          </label>
          <input
            type="text"
            id="username"
            name="username"
            value={formData.username}
            onChange={handleChange}
            placeholder="Введите логин"
            className="w-full mt-1 p-2 border border-gray-300 rounded-lg focus:ring focus:ring-blue-500"
            required
          />
        </div>

        <div className="relative">
          <label htmlFor="password" className="block text-gray-700">
            Пароль
          </label>
          <div className="relative">
            <input
              type={showPassword ? "text" : "password"}
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Введите пароль"
              className="w-full mt-1 p-2 pr-10 border border-gray-300 rounded-lg focus:ring focus:ring-blue-500"
            />
            <span
              onClick={togglePasswordVisibility}
              className="absolute top-1/2 right-3 transform -translate-y-1/2 cursor-pointer text-gray-500">
              <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
            </span>
          </div>
        </div>

        <div className="relative">
          <label htmlFor="confirmPassword" className="block text-gray-700">
            Пароль еще раз
          </label>
          <div className="relative">
            <input
              type={showConfirmPassword ? "text" : "password"}
              id="confirmPassword"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              placeholder="Подтвердите пароль"
              className="w-full mt-1 p-2 pr-10 border border-gray-300 rounded-lg focus:ring focus:ring-blue-500"
            />
            <span
              onClick={toggleConfirmPasswordVisibility}
              className="absolute top-1/2 right-3 transform -translate-y-1/2 cursor-pointer text-gray-500">
              <FontAwesomeIcon icon={showConfirmPassword ? faEyeSlash : faEye} />
            </span>
          </div>
        </div>

        <button
          type="submit"
          className="w-full bg-blue-500 text-white p-2 rounded-lg hover:bg-blue-600 transition">
          Сохранить
        </button>
      </form>
    </div>
  );
}
